import gql from "graphql-tag";

// first step of registration with id and cellphone
export const REGISTER = gql`
  mutation register($id: String!, $cellphone: String!) {
    register(
      id: $id,
      cellphone: $cellphone
    )
  }
`;

export const VERIFY = gql`
  mutation verify($password: String!) {
    verify(
      password: $password
    )
  }
`;

export const UPDATE_REGISTER_DETAILS = gql`
  mutation updateRegisterDetails($data: JSON) {
    updateRegisterDetails(
      data: $data
    )
  }
`;

export const GET_REGISTER_USER = gql`
  query getRegisterUser {
    register
  }
`;

export const LOAD_PERSONAL_INFO = gql`
  query loadPersonalInfo {
    loadPersonalInfo
  }
`;
export const LOAD_PERSONAL_INFO_REPLY = 'loadPersonalInfo';

export const MMTA_PROGRAMS = gql`
  query mmtaPrograms($selectedProgram: String) {
    mmtaPrograms(selectedProgram: $selectedProgram)
  }
`

export const RESET_REGISTER_DETAILS = gql`
  mutation resetRegisterDetails {
    resetRegisterDetails
  }
`

export const LOAD_DEGREE_OPTIONS = gql`
  query loadDegreeOptions {
    loadDegreeOptions
  }
`
